var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42ZM24.0735 40.3102C33.0813 40.3102 40.3837 33.0079 40.3837 24C40.3837 14.9921 33.0813 7.6898 24.0735 7.6898C15.0656 7.6898 7.76327 14.9921 7.76327 24C7.76327 33.0079 15.0656 40.3102 24.0735 40.3102ZM24 39.0612C32.3181 39.0612 39.0612 32.3181 39.0612 24C39.0612 15.6819 32.3181 8.93878 24 8.93878C15.6819 8.93878 8.93878 15.6819 8.93878 24C8.93878 32.3181 15.6819 39.0612 24 39.0612ZM24.0367 37.2245C31.3607 37.2245 37.298 31.2872 37.298 23.9633C37.298 16.6393 31.3607 10.702 24.0367 10.702C16.7128 10.702 10.7755 16.6393 10.7755 23.9633C10.7755 31.2872 16.7128 37.2245 24.0367 37.2245ZM23.2883 13.2488L32.8889 29.904L33.9184 28.118L25.3473 13.2488H23.2883V13.2488ZM14.0816 28.0879L22.2986 13.8329L22.3156 13.8623L22.3317 13.8343L32.0694 30.7272H30.0104L27.5503 26.4595C26.4325 26.1061 25.2424 25.9156 24.0076 25.9156C23.3712 25.9156 22.7501 25.96 22.1462 26.0487L23.332 23.9948C23.5559 23.9838 23.7811 23.9783 24.0076 23.9783C24.762 23.9783 25.5019 24.0394 26.223 24.1569L22.3148 17.3768L15.1112 29.8739L14.0816 28.0879ZM19.6679 27.8712L23.3602 21.4657L22.3307 19.6798L15.9627 30.7271H18.0216L18.0412 30.6932C19.8072 29.63 21.8336 29.0925 24.0464 29.0925C25.4593 29.0925 26.8139 29.3421 28.0686 29.7997L26.6892 27.4104C25.8185 27.2404 24.9335 27.1549 24.0464 27.1554C22.5151 27.1554 21.0426 27.407 19.6679 27.8712Z",
    fill: "url(#paint0_linear_5703_9710)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5703_9710",
    x1: 39.9796,
    y1: 42,
    x2: 13.4204,
    y2: 9.19592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A81FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    stopColor: "#E40C5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4C3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAca);
export default __webpack_public_path__ + "static/media/aca.69ec99ca30ed2765942ac232bd1b29d6.svg";
export { ForwardRef as ReactComponent };